import { FC } from 'react'
import { TableCard } from '../../../../../components/Table/TableCard'
import { TableErrorState } from '../../../../../components/Table/TableStates'
import { DetailField, DetailPanel } from '../../../../../components/DetailPanel/DetailPanel'
import { ConteudoVersaoLeitura } from '../../components/ConteudoVersaoLeitura'
import { ModeloPublicadoHeading } from './components/ModeloPublicadoHeading'
import { useModeloPublicado } from './core/useModeloPublicado'

/** Visualização do modelo publicado da plataforma, do ponto de vista da empresa (T7a AC4). */
export const ModeloPublicadoPage: FC = () => {
  const { data: modelo, isLoading, isError, refetch, catalogo } = useModeloPublicado()

  if (isError) {
    return (
      <TableCard>
        <TableErrorState title='Não foi possível carregar o modelo.' onRetry={refetch} />
      </TableCard>
    )
  }

  if (isLoading || !modelo) {
    return (
      <TableCard>
        <DetailPanel isLoading loadingLabel='Carregando o modelo…' />
      </TableCard>
    )
  }

  return (
    <>
      <ModeloPublicadoHeading modelo={modelo} />
      <TableCard>
        <ConteudoVersaoLeitura
          hash={modelo.hash}
          campos={
            <DetailField
              label='Formato do arquivo'
              value={modelo.formatoVersao ? `v${modelo.formatoVersao}` : undefined}
            />
          }
          regras={modelo.regras}
          formulario={modelo.formulario}
          catalogo={catalogo}
        />
      </TableCard>
    </>
  )
}
